import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Input} from 'kpc';

var _$tmp0 = {
    'placeholder': 'Please enter',
    'showCount': true
};
var _$tmp1 = {
    'placeholder': 'Please enter',
    'showCount': true,
    'maxlength': '10'
};
var _$tmp2 = {
    'type': 'textarea',
    'placeholder': 'please enter',
    'showCount': true,
    'maxlength': '100'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Input, _$tmp0),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Input, _$tmp1),
        _$ce(2, 'br'),
        _$ce(2, 'br'),
        _$cc(Input, _$tmp2)
    ], 4 /* HasNonKeyedChildren */);
};